var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCeg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-edf2691c-615e-4ac9-9386-1cb20dd9c01e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-d5564405-5845-4eb7-a23a-ff0d8240feaf{fill:#fff;}.uuid-7be49d72-eaba-452b-ba57-0d0038acef7b{fill:url(#uuid-eea5213c-f9e6-405a-93c4-7fba7eb0993d);}.uuid-5bd8bfac-669e-4a06-88f5-05e4e8a8f73a{fill:url(#uuid-5507b804-547d-4719-9618-d213c12843b0);}.uuid-a39c3de9-9090-4303-8647-ee860e778dc0{fill:url(#uuid-dac2e90f-99f3-44e1-a0f9-6848eb27fe81);}.uuid-ac23b9c4-b5c9-41c3-80ef-540ae01a3aeb{fill:url(#uuid-46b3aa2f-8494-48ab-a6ec-a21ce4a8056d);}.uuid-4fc3ca5a-42d0-401e-90a3-c37b61ca51c3{fill:url(#uuid-594e0113-795e-420a-9732-6e3a893f2adc);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-eea5213c-f9e6-405a-93c4-7fba7eb0993d",
    x1: 115.41,
    y1: 4991.93,
    x2: 410.49,
    y2: 5000.4,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-594e0113-795e-420a-9732-6e3a893f2adc",
    x1: 176.99,
    y1: 5057.21,
    x2: 447.64,
    y2: 5066.37,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e93d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164899"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-5507b804-547d-4719-9618-d213c12843b0",
    x1: 172.68,
    y1: 5051.53,
    x2: 410.14,
    y2: 5047,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f94d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#164899"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-46b3aa2f-8494-48ab-a6ec-a21ce4a8056d",
    x1: 67.38,
    y1: 4924.56,
    x2: 333.4,
    y2: 4942.88,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#029148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3c33d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-dac2e90f-99f3-44e1-a0f9-6848eb27fe81",
    x1: 87.8,
    y1: 4941.89,
    x2: 349,
    y2: 4946.42,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#008f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#b1c23e"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-d5564405-5845-4eb7-a23a-ff0d8240feaf",
    d: "m-.5-.5h513v513s-513,0-513,0V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-7be49d72-eaba-452b-ba57-0d0038acef7b",
    d: "m150.42,231.38s28.56-2.95,56.83-2.95,104.99,9.16,123.41,9.16,60.97-4.92,73.08-11.13c-1.58,1.18-42.15,54.37-42.15,54.37,0,0-32.01,3.94-56.34,3.94s-88.64-8.77-128.23-8.77-68.75,9.55-68.75,9.55l42.15-54.17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-4fc3ca5a-42d0-401e-90a3-c37b61ca51c3",
    d: "m177.21,210.69s46.49-42.65,95.24-42.65,69.53,4.33,103.12,4.33,55.75-3.64,67.56-14.87c-10.24,21.96-25.8,46.59-25.8,46.59,0,0-20.29,14.08-69.53,14.08s-85.69-6.7-119.86-7.68c-34.08-.98-50.62.2-50.62.2h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-5bd8bfac-669e-4a06-88f5-05e4e8a8f73a",
    d: "m417.03,204.29c-2.17,1.38-20.39,12.31-51.51,6.4-33.09-6.4-69.63-22.36-107.65-21.96-38.02.39-78.5,20.39-80.66,21.96,0,0,16.64-1.18,50.72-.2,34.08.98,70.52,7.68,119.86,7.68,46.29,0,66.97-12.51,69.24-13.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-ac23b9c4-b5c9-41c3-80ef-540ae01a3aeb",
    d: "m334.79,301.31s-46.49,42.65-95.24,42.65-69.53-4.33-103.12-4.33-55.75,3.64-67.56,14.87c10.24-21.96,25.8-46.59,25.8-46.59,0,0,20.29-14.08,69.53-14.08s85.69,6.7,119.86,7.68c34.08.98,50.62-.2,50.62-.2h.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-a39c3de9-9090-4303-8647-ee860e778dc0",
    d: "m94.97,307.71c2.17-1.38,20.39-12.31,51.51-6.4,33.09,6.4,69.63,22.36,107.65,21.96,38.02-.39,78.5-20.39,80.66-21.96,0,0-16.64,1.18-50.72.2-34.08-.98-70.52-7.68-119.86-7.68-46.29,0-66.97,12.41-69.24,13.89Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCeg);
export default __webpack_public_path__ + "static/media/icon_ceg.0c57c4d6ea0690ade545e997e740e26a.svg";
export { ForwardRef as ReactComponent };